<template lang="pug">
  div
    .wrapper(v-if="!falseInfo")
      #breadcrumb.ml-1.ml-md-0(v-if="isBreadcrumbShow")
        nav(aria-label='breadcrumb')
        ol.breadcrumb
          li.breadcrumb-item
            a(@click="changeTabAndRouterPush('rockyDetail')") {{rockyName}}
          li.breadcrumb-item(v-if="isBreadcrumbRockListShow & isBreadcrumbRockShow")
            a(@click="changeTabAndRouterPush('rockList')") 岩一覧
          li.breadcrumb-item(v-if="isBreadcrumbRouteListShow & isBreadcrumbRockShow")
            a(@click="changeTabAndRouterPush('routeList')") ルート一覧
          li.breadcrumb-item(v-if="isBreadcrumbMovieShow & isBreadcrumbRockShow")
            a(@click="changeTabAndRouterPush('movieList')") 動画一覧
          li.breadcrumb-item.active(aria-current='page' v-if="isBreadcrumbRockListShow & !isBreadcrumbRockShow") 岩一覧
          li.breadcrumb-item.active(aria-current='page' v-if="isBreadcrumbRouteListShow & !isBreadcrumbRockShow") ルート一覧
          li.breadcrumb-item.active(aria-current='page' v-if="isBreadcrumbMovieShow & !isBreadcrumbRockShow") 動画一覧
          li.breadcrumb-item.active(aria-current='page' v-if="isBreadcrumbRockShow") {{rockName}}

    div.text-center(v-if="falseInfo")
      .my-5 情報の取得に失敗しました
      buttom.my-2(@click.prevent="$router.go(-1)" style="cursor: pointer; color:blue") 前のページに戻る
    //-岩場画像(タブの選択内容によってheightが可変)
    #rocky-top-img(:style="{backgroundImage:'url('+rockyImgPath+')',height:rockyTopImgHeight}" v-if="isRockyTopImgDisp")
      #rocky-info(v-bind:class="{rockyInfoMove:!isCheckinUserListShow}")
        //-岩場名、住所、レベル
        #checkin-info(v-if="isCheckinUserListShow" @click="showRockyCheckinUserList()") 本日{{checkInCount}}人がチェックイン！
        #rockyNameKana {{rockyNameKana}}
        #name <b>{{rockyName}}</b>
        #address {{address}}
        #level 
          span(v-html="rockyLevelB" v-if="rockyLevelB != ''" )
          span(v-html="rockyLevelR" v-if="rockyLevelR != ''" )

    .container-fluid.wrapper(v-if="!falseInfo")
      //- snsボタン
      #share.d-flex.justify-content-end(v-if="isRockyTopImgDisp")
        a(:href="getLink('facebook')" target="_blank" rel="noopener")
          img(src="../../assets/Facebook_logo.png" alt="")
        a(:href="getLink('twitter')" target="_blank" rel="noopener")
          img(src="../../assets/Twitter_logo.png" alt="")
        a(:href="getLink('line')" target="_blank" rel="noopener")
          img(src="../../assets/Line_logo.png" alt="")
      div(v-if="!isRockImgListContainerLoading")
        //-岩場の特記事項
        #rocky-remarks
          #rocky-remarks-inner(v-if="isShowInfo")
            .info(v-for="info in this.remarkList")
              i.fas.fa-info-circle 
              |{{info}}

      //- タブ
      #tab-box.d-flex.justify-content-around
        .tab(:class="{'active':isTopTab}" @click="changeTabAndRouterPush('rockyDetail')") 岩場情報
        .tab(:class="{'active':isRockListTab}" @click="changeTabAndRouterPush('rockList')") 岩・トポ
        .tab(:class="{'active':isRouteListTab}" @click="changeTabAndRouterPush('routeList')") ルート一覧
        //- 動画が存在する場合のみタブ表示
        .tab(v-if="movies.length > 0"
          :class="{'active':isMovieTab}" @click="changeTabAndRouterPush('movieList')") 動画
      //-MAP
      #parent-area
        //- Map
        .spinner
          b-spinner.mt-5.mb-5(variant="primary" label="Loading..." v-if="isMapComponentLoading")
        #map-container(v-if="!isMapComponentLoading")
          #rocky-map-inner.position-relative(v-if="isMapShow" :style="{height:mapHeight}"  )
            RockyMapComponent(ref="map" 
                :rockyName = "rockyName",
                :rockyLngLat = "rockyLngLat",
                :address = "rockyInfo['address']",
                :zoom = "MAP_ZOOM_DEFAULT",
                :gestureHandling = "cooperative",
                :lat = "Number(mapCenterLat)" , 
                :lng = "Number(mapCenterLng)",
                :isCsSpaCtlShow = "true",
                :rockyInfoApiData = "rockyInfoApiData" 
                v-if = "!isMapComponentLoading")
          .text-right(v-if="mapHeight != '0px'") ※岩の位置やマップ上の表示は目安としてご利用ください<br>（地図の表示倍率や調査時のGPS状況により実際の位置と異なる場合があります。）
      //-childコンポーネントのrouter-view
      #child-area
        router-view(ref="myPageChild")

      //-岩場トップページの場合表示するエリア
      #parent-area
        //-グラフ
        #chart-container(v-if="isLevelChartShow && isTopTab")
          #chart-container-innner
            #guide
              p ルート数
            #bar-chart
              #bar-box-innner
                .box(v-for='(item, index) in levelChartData.datasets[0].data')
                  .bar
                    .bar-line(v-bind:style="{height: getLevelChartHeight(item) + 'px' }")
                    a(v-bind:style="{bottom: getLevelChartLabelHeight(item) + 'px' }") {{ item != 0 ? item : '' }}
                  
                  .index
                    .bolder
                      a {{boulderLabelList[index]}}
                    .rope
                      a {{ropeLabelList[index]}} 

        .full-width-wrapper.mt-5.mb-5.text-center#topo_button(v-if="isTopTab")    
          button.btn.btn-info.btn-lg.w-75(type='button' @click="changeTabAndRouterPush('rockList')") トポを見る

        .full-width-wrapper.mt-5.mb-5.text-center#topo_button(v-if="isTopTab && isDemoLocky")
          button.btn.btn-info.btn-lg.w-75(type='button' @click="changeTabAndRouterPush('movieList')") 動画を見る

        //- チェックイン状況のグラフ
        .spinner(v-if="isTopTab")
          b-spinner.mt-5.mb-5(variant="primary" label="Loading..." v-if="isGraphContainerLoading")
        .full-width-wrapper(v-if="!isGraphContainerLoading && isTopTab")
          .headline.mt-3 直近1ヶ月のチェックイン状況
          .chart(v-if="isChartShow")
            Chart(:chartData="chartData",:options="options",:height="200")
          .chart-data-not-exist(v-else) {{chartMessage}}

        //- 岩場情報
        .full-width-wrapper.mt-4.mb-5(v-if="isTopTab")
          .headline.mt-3 岩場データ
          div.rockydata
            //- 駐車場
            div(v-if='parkingList.length > 0')
              div.pt-3.ml-3 
                b 駐車場
              div.pt-2(v-for='parking in parkingList')
                div
                  span.ml-5 {{parking.name}}
                  span.ml-1(v-if="parking.units.length > 0 ") （{{parking.units}}）
                  span.ml-1 {{parking.info}}

            //- お手洗い
            div(v-if='restroomList.length > 0')
              div.pt-3.ml-3 
                b トイレ
              div.pt-2(v-for='restroom in restroomList')
                div
                  span.ml-5 {{restroom.name}}
                  span.ml-1 {{restroom.info}}

            //- 入山申請
            div(v-if='climberReceptionList.length > 0')
              div.pt-3.ml-3 
                b その他
              div.pt-2(v-for='climberReception in climberReceptionList')
                div
                  span.ml-5 {{climberReception.name}}
                  span.ml-1 {{climberReception.info}}
                div.ml-5(v-if="climberReception.url.length > 0 ") 
                  span （
                  a(:href="climberReception.url" target='_blank' rel='noopener') 詳細を見る
                  span ）

            //- 施設・ショップ
            div(v-if='facilityList.length > 0')
              div.pt-3.ml-3 
                b 近くのショップ
              div.pt-2(v-for='facility in facilityList')
                  ul
                    span
                        a(:href="facility.url" target='_blank' rel='noopener') {{facility.name}}
                    li.ml-4
                      span 営業時間: {{facility.businessHours}}
                    li.ml-4(v-if="facility.info")
                      span {{facility.info}}

            div.pt-5.ml-3 アクセス・駐車場・現地情報を募集中です。
            div.pt-3
              div.ml-3.mb-5.pb-3
                button.btn.btn-info.btn-sm(type='button' @click="doRouterPush('feedBack')") 岩場情報を投稿する

      FeedBack
</template>


<script>
import RockyMapComponent from '@/components/rockyInfo/rockyId/rockyMapComponent.vue'
import FeedBack from '@/components/feed_back/FeedBackLink.vue'
import Chart from '@/components/chart/bar_chart.vue'
import axios from 'axios'

export default {
  //mixins: [offlineMap],
  // データオブジェクト
  data() {
    return {
      //デフォルト値
      isLogin:false,
      rockyId:null,
      rockId:null,
      rockName:'',
      isDemoLocky: false, 
      //岩場画像の高さ
      rockyTopImgHeight: '180px',
      ROCKY_TOP_IMG_HEIGHT_HIGH:'350px',
      ROCKY_TOP_IMG_HEIGHT_LOW:'180px',
      //Mapの高さ
      mapHeight: '250px',
      MAP_HEIGHT_HIGH : '250px',
      MAP_HEIGHT_LOW : '250px',
      MAP_HEIGHT_ZERO : '0px',
      //MapのZoom値
      MAP_ZOOM_DEFAULT : 10,
      MAP_ZOOM_ROCK : 15,
      //MAP表示
      isExpanded: false,
      //岩場アイコン表示用
      rockyLngLat:null,
      mapCenterLat:null,
      mapCenterLng:null,
      //MAPコンポーネント引き渡し用
      rockyInfoApiData: null,
      cooperative: "cooperative",
      //岩画面表示
      rockyName:'',
      rockyNameKana:'',
      address:null,
      level:null,
      csList:[],
      spaList:[],
      rockList:null,
      routeList: null,
      rockyInfo:null,
      rockyImgPath:null,
      remarkList:[],
      isShowInfo:false,
      //rocky-InfoAPIの戻り値を保持
      rockyMasterData:null,
      //チェックイン中ユーザーのリスト
      apiCheckInData:null,
      apiCheckInUserList:[],
      checkInUserList:[],
      checkInCount:0,
      checkInOtherCount:0,
      checkinOtherUserMessage:'',
      isCheckinUserListShow:false,
      //本日の岩別のチェックイン数
      checkInAggregateList:[],
      //岩場のレベル
      rockyLevelB:'',
      rockyLevelR:'',
      //レベルのグラフ
      isLevelChartShow:false,
      levelChartData:{},
      levelChartDataMax:0,
      levelChartOptions:{},
      levelChartMessage:'',
      //グラフ
      isChartShow:false,
      chartData:{},
      options:{},
      chartMessage:'',
      //付加情報
      parkingList:[],
      restroomList:[],
      facilityList: [],
      climberReceptionList:[],
      movies: [],
      //Loading表示用
      isMapComponentLoading:true,
      isRockyInfoContainerLoading:true,
      isRockImgListContainerLoading:true,
      isGraphContainerLoading:true,
      falseInfo: false,
      //レベルグラフ
      boulderLabelList:[
        '10級','9級','8級','7級','6級','5級','4級','3級',
        '2級','1級','初段','二段','三段','四段','五段','六段'
      ],
      ropeLabelList:[
        '5.2\n5.3\n5.4','5.5\n5.6','5.7\n5.8','5.9\n10a',
        '10b\n10c','10d\n11a\n11b','11c\n11d','12a\n12b',
        '12c\n12d','13a\n13b','13c\n13d','14a','14b','14c','14d','15a'
      ],
      //タブの表示制御
      isTopTab:true,
      isRockListTab:false,
      isRouteListTab: false,
      isMovieTab:false,
      //岩場画像の表示制御
      isRockyTopImgDisp:true,
      //Mapの表示制御
      isMapShow:true,
      //パンくず
      isBreadcrumbShow:false,
      isBreadcrumbRockListShow:false,
      isBreadcrumbRouteListShow:false,
      isBreadcrumbMovieShow:false,
      isBreadcrumbRockShow:false,
    }
  },
  // コンポーネント
  components: {
    RockyMapComponent,
    FeedBack,
    Chart
  },
  watch: {
    async $route(to, from) {
      // 画面遷移の際に、表示項目の制御を行う
      this.controlDispItems(to.name, false)
    }
  },
  // インスタンス作成後
  created() {
    // 岩場情報を取得する
    this.createdProcess()
  },
  mounted(){},
  beforeDestroy() {
  },
  // メソッド
  methods: {
    //-------------------------------------------------
    // created時の処理(岩一覧画面、岩画面への直接アクセスの場合も呼ばれる)
    // 岩場情報の取得
    //-------------------------------------------------
    async createdProcess(){
      this.rockyId = this.$route.params.rockyId
      this.isLogin = this.$user.isLogin

      this.isDemoLocky = this.rockyId == process.env.VUE_APP_DEMO_ROCKY_ID

      //チェックイングラフのデータ取得
      this.setChartData()
      //チェックイン中のユーザー取得
      await this.setCheckingInData()

      //岩場データ(岩場情報,岩List)
      await this.getRockyMasterData(this.rockyId, this.isLogin)
      .then(response => {
        this.rockyInfoApiData = response.data
      })
      .catch(function (error) {
        this.falseInfo = true
      })

      //データが0件の場合、検索画面に戻る
      if(this.rockyInfoApiData.length == 0){
        await this.asyncDialog('該当する岩場は存在しません。')
        this.$router.push('/')
      }

      //取得した値をセットする
      let rockyDataRecord = this.rockyInfoApiData[0]
      this.routeList = rockyDataRecord.routeList
      //岩場情報
      this.rockyName = rockyDataRecord.rockyName
      this.rockyNameKana = rockyDataRecord.rockyNameKana
      this.address = rockyDataRecord.rockyInfo.address
      this.movies = rockyDataRecord.rockyInfo.movieList
      //コンビニ、温泉情報
      let wkScList = []
      rockyDataRecord.rockyInfo.csList.forEach((cs) => {
        wkScList.push({
          distance : cs.distance,
          lat : cs.longitudelatitude.split(',')[0],
          lng : cs.longitudelatitude.split(',')[1],
          name : cs.name,
          no : cs.no,
          url : cs.url
        })
      })
      this.csList = wkScList
      let wkSpaList = []
      rockyDataRecord.rockyInfo.spaList.forEach((spa) => {
        wkSpaList.push({
          distance : spa.distance,
          lat : spa.longitudelatitude.split(',')[0],
          lng : spa.longitudelatitude.split(',')[1],
          name : spa.name,
          no : spa.no,
          url : spa.url,
          info : spa.info
        })
      })
      this.spaList = wkSpaList
      
      //岩場名をセットする(無名の岩対応)
      this.rockList = this.setRockName(rockyDataRecord.rockList)
      //岩Listに対する処理
      this.remarkList = []
      this.rockList.forEach((rock) => {
        //特記事項をListにセットする
        if(rock.dbComment != null){
          this.remarkList.push(rock.dbComment)
          this.isShowInfo = true
        }
        //岩のチェックイン数をセットする
        rock['checkinCount'] = this.getRockCheckInCount(rock.id)
      })

      this.rockyInfo = rockyDataRecord.rockyInfo

      if(this.rockyInfo.parkingList != undefined){
        this.parkingList = this.rockyInfo.parkingList
      }
      if(this.rockyInfo.restroomList != undefined){
        this.restroomList = this.rockyInfo.restroomList
      }
      if(this.rockyInfo.climberReceptionList != undefined){
        this.climberReceptionList = this.rockyInfo.climberReceptionList
      }
      if(this.rockyInfo.facilityList != undefined){
        this.facilityList = this.rockyInfo.facilityList
      }

      //岩場画像
      this.rockyImgPath = process.env.VUE_APP_MATERIAL_URL + rockyDataRecord.imgList[0].path
      //岩場座標
      this.rockyLngLat = this.rockyInfo.longitudelatitude
      this.mapCenterLat = this.getLatLng(this.rockyLngLat)[0]
      this.mapCenterLng = this.getLatLng(this.rockyLngLat)[1]
      // 以降の処理で使用できるよう保持しておく
      this.rockyMasterData = rockyDataRecord

      //レベルのグラフデータをセットする
      await this.setLevelChartData()

      //MAPのLoading解除
      this.isMapComponentLoading = false
      this.isRockyInfoContainerLoading = false

      //岩の特記事項、岩画像Listを描画する
      this.isRockImgListContainerLoading = false

      //最近見た岩場のデータ更新する
      this.pushRecentRocky()

      //ページtitleを岩場名にする。(seo対策)
      document.title = this.rockyName + ' | ' + process.env.VUE_APP_TITLE

      this.controlDispItems(this.$route.name, true)
    },
    //------------------------------
    //パスによって表示項目を制御する
    //------------------------------
    async controlDispItems(pathName, isCreated){
      //一旦全タブをfalseにする
      this.isTopTab = false
      this.isRockListTab = false
      this.isRouteListTab = false
      this.isMovieTab = false

      switch(pathName) {
        // 岩場画面の場合
        case 'rockyInfo_:rockyId':
          this.isMapShow = true
          this.mapHeight = this.MAP_HEIGHT_HIGH
          this.isRockyTopImgDisp = true
          this.isTopTab = true
          this.isBreadcrumbShow = false
          this.isBreadcrumbRockListShow = false
          this.isBreadcrumbRouteListShow = false
          this.isBreadcrumbMovieShow = false
          this.isBreadcrumbRockShow = false
          if(!isCreated){
            if(this.rockyInfoApiData[0].imgList[0].path.match('no_img')){
              // 未撮影の岩場の場合Mapに岩場の中心マーカーを表示する
              this.$refs.map.showRockyCenterMarker()
            }else{
              //岩マーカー表示
              this.$refs.map.showRockMarker(false)
            }
            // Mapを地図表示にする
            this.$refs.map.changeMapTypeId('ROADMAP')
          }
          break
        // 岩一覧の場合
        case 'rockyInfo_:rockyId_rockList':
          this.isMapShow = true
          this.mapHeight = this.MAP_HEIGHT_LOW
          this.isRockyTopImgDisp = false
          this.isRockListTab = true
          this.isBreadcrumbShow = true
          this.isBreadcrumbRockListShow = true
          this.isBreadcrumbRouteListShow = false
          this.isBreadcrumbMovieShow = false
          this.isBreadcrumbRockShow = false
          if(!isCreated){
            this.$refs.map.deleteScSpaButton()
            this.$refs.map.showRockMarker(true)
            // Mapを航空写真にする
            this.$refs.map.changeMapTypeId('SATELLITE')
          }
          break
        // ルート一覧の場合
        case 'rockyInfo_:rockyId_routeList':
          this.isMapShow = true
          this.mapHeight = this.MAP_HEIGHT_LOW
          this.isRockyTopImgDisp = false
          this.isRouteListTab = true
          this.isBreadcrumbShow = true
          this.isBreadcrumbRockListShow = false
          this.isBreadcrumbRouteListShow = true
          this.isBreadcrumbMovieShow = false
          this.isBreadcrumbRockShow = false
          if(!isCreated){
            this.$refs.map.deleteScSpaButton()
            this.$refs.map.showRockMarker(false)
            // Mapを航空写真にする
            this.$refs.map.changeMapTypeId('SATELLITE')
          }
          break
        // 岩画面の場合
        case 'rockyInfo_:rockyId_:rockId':
          this.isMapShow = true
          this.mapHeight = this.MAP_HEIGHT_LOW
          this.isRockyTopImgDisp = false
          this.isRockListTab = true
          this.isBreadcrumbShow = true
          this.isBreadcrumbRockListShow = true
          this.isBreadcrumbRouteListShow = false
          this.isBreadcrumbMovieShow = false
          this.isBreadcrumbRockShow = true
          if(!isCreated){
            this.$refs.map.deleteScSpaButton()
            // Map上の対象の岩マーカーをアクティブにする
            this.$refs.map.changeRockMarkerActive(null)
            // MapのZoom変更
            this.$refs.map.changeMapZoom(this.MAP_ZOOM_ROCK)
            // Mapを航空写真にする
            this.$refs.map.changeMapTypeId('SATELLITE')
          }
          break
        // 動画一覧の場合
        case 'rockyInfo_:rockyId_movieList':
          this.isMapShow = true
          this.mapHeight = this.MAP_HEIGHT_ZERO
          this.isRockyTopImgDisp = false
          this.isMovieTab = true
          this.isBreadcrumbShow = true
          this.isBreadcrumbRockListShow = false
          this.isBreadcrumbRouteListShow = false
          this.isBreadcrumbMovieShow = true
          this.isBreadcrumbRockShow = false
          if(!isCreated){
            this.$refs.map.deleteScSpaButton()
          }
          break
      }
    },
    //------------------------
    //最近見た岩場のデータ更新
    //------------------------
    async pushRecentRocky(){
      //未ログイン時は何もしない
      if(!this.$user.isLogin){
        return
      }
      //API実行
      const url = process.env.VUE_APP_API_GATEWAY + '/api-user-info'
      const params = {
        rockyId : this.rockyId,
        resetFlg : false
      }
      //更新実行
      try {
        await axios.patch(url, params, {
          headers: {
            'Authorization': this.$user.idToken
          }
        })
      } catch(err) {
        //TODO:エラー処理
        // alert('岩場参照履歴を更新できませんでした。')
        return
      }

    },

    //---------------------
    //岩の名前に連番を付ける
    //---------------------
    setRockName(rockList){
      let count = 0
      rockList.forEach((rock) => {
        count = count + 1
        let cntStr = count + '．'
        if(rock.name == null){
          rock.name = cntStr + '（岩名なし）'
        }else{
          rock.name = cntStr + rock.name
        }
      })
      return rockList
    },
    //--------------------------
    //岩のチェックイン数を取得する
    //--------------------------
    getRockCheckInCount(rockId){
      //岩IDに紐付くチェックイン数を取得する
      let targetRockList = this.checkInAggregateList.filter(record => record.rockId == rockId)
      if(targetRockList.length > 0){
        //当日チェックインしたユーザーが存在する場合
        return targetRockList[0].count
      }
      return 0
    },
    //---------------
    // 岩場データ取得
    //---------------
    getRockyMasterData: (paramRockyId,isLogin) => new Promise((resolve, reject) => {
      const jsonUrl = process.env.VUE_APP_API_GATEWAY + '/api-search-rocky/rocky-info?rockyId=' + paramRockyId + '&isLogin=' + isLogin
      axios.get(jsonUrl)
      .then(res => resolve(res))
      .catch(err => reject(err))
    }),

    //---------------------------------------------
    //岩場、岩のレベルデータ取得
    //---------------------------------------------
    getRockyGrade: (rockyId) => new Promise((resolve, reject) => {
      const jsonUrl = process.env.VUE_APP_API_GATEWAY + '/api-search-rocky/rocky-grade'
      axios.get(jsonUrl, {
        params: {"rockyId": rockyId},
        headers: {}
      })
      .then(res => resolve(res.data))
      .catch(err => reject(err))
    }),

    //---------------
    // ダイアログ表示
    //---------------
    asyncDialog(msg) {
      return new Promise((resolve) => {
        this.$bvModal.msgBoxOk(msg, {
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
        .then(value => {
          resolve(value)
        })
        .catch(err => {
          // An error occurred
        })
      })
    },
    //---------------------------------------------
    //レベルのグラフのデータを取得してセットする
    //---------------------------------------------
    async setLevelChartData(){
      //APIを実行してデータ取得
      let rockyGradeObj = await this.getRockyGrade(this.rockyId)

      //データが存在しない場合
      if(rockyGradeObj.length == 0){
        //エラー処理
        return
      }

      //岩場全体のレベル
      let rockyGradeRange = rockyGradeObj[0].rockyGradeRange
      let rockyBlMin = rockyGradeRange.bl.min == null ? '' : rockyGradeRange.bl.min
      let rockyBlMax = rockyGradeRange.bl.max == null ? '' : rockyGradeRange.bl.max
      let rockyRcMin = rockyGradeRange.rc.min == null ? '' : rockyGradeRange.rc.min
      let rockyRcMax = rockyGradeRange.rc.max == null ? '' : rockyGradeRange.rc.max

      //岩のレベル
      let wkRockyLevelList = rockyGradeObj[0].rockyLevelList
      //岩単位のレベル
      let wkRockLevelList = rockyGradeObj[0].rockList
      let blCnt = 0
      let rcCnt = 0
      //岩場のルート本数を算出
      wkRockyLevelList.forEach((item) => {
        blCnt += item.bl
        rcCnt += item.rc
      })

      let mark = '' 

      //岩場のレベル
      if(blCnt > 0){
        this.rockyLevelB = 'ボルダー：'  + blCnt + '本'
        mark = (rockyBlMin==null && rockyBlMax==null) ? '' :'～'
        this.rockyLevelB = this.rockyLevelB +'（' + rockyBlMin + mark + rockyBlMax + '）' + '<br>'
      }

      if(rcCnt > 0){
        this.rockyLevelR = 'ロープ：' + rcCnt + '本'
        mark = (rockyRcMin==null && rockyRcMax==null) ? '' :'～'
        this.rockyLevelR = this.rockyLevelR + '（' + rockyRcMin + mark + rockyRcMax + '）'
      }
      //岩のレベル
      this.rockList.forEach((item) => {
        let targetRock = wkRockLevelList.filter(record => record.rockId == item.id)[0]
        let rockBlCnt = targetRock.bl.cnt
        let rockBlMin = targetRock.bl.min == null ? '' : targetRock.bl.min
        let rockBlMax = targetRock.bl.max == null ? '' : targetRock.bl.max
        let rockRcCnt = targetRock.rc.cnt
        let rockRcMin = targetRock.rc.min == null ? '' : targetRock.rc.min
        let rockRcMax = targetRock.rc.max == null ? '' : targetRock.rc.max

        item.blLevel = ''
        if(rockBlCnt > 0){
          item.blLevel = 'ボルダー：' + rockBlCnt + '本 '
          if(rockBlMin == rockBlMax){
            item.blLevel = item.blLevel + '（' + rockBlMin + '）'
          }else{
            mark = (rockBlMin=='' && rockBlMax=='') ? '' :'～'
            item.blLevel = item.blLevel + '（' + rockBlMin + mark + rockBlMax + '）'
          }
        }
    
        if(rockRcCnt > 0){
          item.rcLevel = 'ロープ：' + rockRcCnt + '本 '
          if(rockRcMin == rockRcMax){
            item.rcLevel = item.rcLevel + '（' + rockRcMin + '）'
          }else{
            mark = (rockRcMin=='' && rockRcMax=='') ? '' :'～'
            item.rcLevel = item.rcLevel + '（' + rockRcMin + mark + rockRcMax + '）'
          }
        }
      })

      //------------------------
      //グラフに表示するデータ
      //------------------------
      //初めに16段階分要素をセットして、取得した値をセットする
      let wkList = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
      wkRockyLevelList.forEach((item) => {
        wkList[item.level-1] = item.bl + item.rc
      })

      let wkDatasets = [
        {
          label: 'ルート数',
          backgroundColor:'#006fbe',
          data: wkList
        }
      ]

      //縦棒グラフ用
      this.levelChartData = {
        datasets: wkDatasets
      }

      //グラフの棒を描画する際に使用する値をセット
      this.levelChartDataMax =  Math.max.apply(null,this.levelChartData.datasets[0].data)

      //データのセットが完了したタイミングでグラフ描画する
      this.isLevelChartShow = true
      this.isGraphContainerLoading = false

    },
    //---------------------------------------------
    //グラフのデータを取得してセットする
    //---------------------------------------------
    async setChartData(){
      //APIを実行してデータ取得
      let recentCheckInCountList = await this.getRecentCheckInCount(this.rockyId)

      //グラフに表示するデータが存在しない場合
      if(recentCheckInCountList.length == 0){
        this.isChartShow = false
        this.isGraphContainerLoading = false
        this.chartMessage = 'ここ１ヶ月のヤマラボユーザーのチェックイン記録はありません。'
        return
      }

      //グラフ棒の色
      const CHART_BACKGROUND_WEEKDAY = '#bfc5c9'
      const CHART_BACKGROUND_SATURDAY = '#7dbae5'
      const CHART_BACKGROUND_SUNDAY_HOLIDAY = '#f0b5ba'
      //グラフのラベルを保持するList
      let labelList = []
      //グラフ棒の色を保持するList
      let backgroundColorList = []
      //グラフのデータを保持するList
      let dataList = []
      //APIから取得したデータを処理
      recentCheckInCountList.forEach((item) => {
        //ラベル
        labelList.push(item.date+'('+ item.week +')')
        //グラフの棒の色
        if(item.week == '土'){
          backgroundColorList.push(CHART_BACKGROUND_SATURDAY)
        }else if(item.week == '日'){
          backgroundColorList.push(CHART_BACKGROUND_SUNDAY_HOLIDAY)
        }else{
          backgroundColorList.push(CHART_BACKGROUND_WEEKDAY)
        }
        //グラフのデータ
        dataList.push(item.count)
      })

      //画面表示用のobjにセットする
      this.chartData = {
        labels : labelList,
        datasets:[{
          label : 'チェックイン数',
          //グラフの棒の色(可変にする為に、全要素分指定する)
          backgroundColor : backgroundColorList,
          //グラフのデータとなるチェックイン数
          data : dataList
        }]
      }
      //チェックイン数グラフのオプション
      this.options = {
        responsive: true, //レスポンシブ
        maintainAspectRatio: false, //サイズ変更の際に、元のキャンバスのアスペクト比を維持するかどうか
        animation: false, //アニメーション
        legend: {           //凡例設定
            display: false  //表示設定
        },
        title: {            //タイトル設定
            display: false, //表示設定
            fontSize: 18,   //フォントサイズ
            text: 'タイトル' //ラベル
        },
        scales: {                          
            //軸設定
            yAxes: [{          //y軸設定
                display: true, //表示設定
                scaleLabel: {  //軸ラベル設定
                    display: false,                //表示設定
                    labelString: '',  //ラベル
                    fontSize: 10                 //フォントサイズ
                },
                ticks: {           //最大値最小値設定
                    min: 0,        //最小値
                    //max: 20,       //最大値
                    //fontSize: 15,  //フォントサイズ
                    stepSize: 5    //軸間隔
                },
            }],
        },
        layout: {         //レイアウト
            padding: {    //余白設定
                left: 0,
                right: 0,
                top: 10,
                bottom: 0
            }
        }
      }

      //for debag------------------------------------↓↓↓
      // this.chartData = {
      //   labels: ['3/1(月)','2(火)','3(水)','4(木)','5(金)','6(土)','7(日)',
      //         '8(月)','9(火)','10(水)','11(木)','12(金)','13(土)','14(日)',
      //         '15(月)','16(火)','17(水)','18(木)', '19(金)', '20(土)', '21(日)',
      //         '22(月)', '23(火)', '24(水)', '25(木)', '26(金)', '27(土)', '28(日)',
      //         '29(月)', '30(火)', '31(水)'],
      //   datasets: [
      //     {
      //       label: 'チェックイン数',
      //       backgroundColor:['#bfc5c9', '#bfc5c9', '#bfc5c9', '#bfc5c9', '#bfc5c9', '#7dbae5', '#f0b5ba',
      //         '#bfc5c9', '#bfc5c9', '#bfc5c9', '#bfc5c9', '#bfc5c9', '#7dbae5', '#f0b5ba',
      //         '#bfc5c9', '#bfc5c9', '#bfc5c9', '#bfc5c9', '#bfc5c9', '#7dbae5', '#f0b5ba',
      //         '#bfc5c9', '#bfc5c9', '#bfc5c9', '#bfc5c9', '#bfc5c9', '#bfc5c9', '#f0b5ba',
      //         '#bfc5c9', '#bfc5c9', '#bfc5c9'],
      //       data: [10, 10, 2, 1, 1, 0, 5, 
      //             6, 10, 12, 1, 1, 10, 10, 
      //             2, 1, 1, 0, 5, 6, 10,
      //             12, 1, 20, 10, 2, 1, 1, 
      //             0,2,6,2]
      //     }
      //   ]
      // }
      //for debag------------------------------------↑↑↑

      //データのセットが完了したタイミングでグラフ描画する
      this.isChartShow = true
      this.isGraphContainerLoading = false

    },
    //---------------------------------------------
    //岩場のチェックイン数(グラフ用データ)を取得する
    //---------------------------------------------
    getRecentCheckInCount: (rockyId) => new Promise((resolve, reject) => {
      const jsonUrl = process.env.VUE_APP_API_GATEWAY + '/api-checkin/recent-checkin-count'
      axios.get(jsonUrl, {
        params: {"rockyId": rockyId},
        headers: {}
      })
      .then(res => resolve(res.data))
      .catch(err => reject(err))
    }),

    //---------------------------------------------
    //レベルグラフの縦棒の高さを返す
    //---------------------------------------------
    getLevelChartHeight(item){
      const max = this.levelChartDataMax
      if(max < 35){
        return item * 3
      }else if(max < 52){
        return item * 2
      }else{
        return item *1.5
      }
    },
    //---------------------------------------------
    //レベルグラフのラベルの位置を返す
    //---------------------------------------------
    getLevelChartLabelHeight(item){
      if(item < 5){
        return item + 1 
      }else{
        if(this.levelChartDataMax < 55){
          if(item < 11){
            return item - 5
          }else{
            return item * 1.5
          }
        }else{
          return item -10
        }
      }
    },
    //--------------------------------------------
    // 現在チェックイン中のユーザーを取得してセットする
    //--------------------------------------------
    async setCheckingInData(){

      //APIを実行してthis.apiCheckInDataにデータセット
      await this.getCheckingInUserAndCount(this.rockyId)

      //岩場のチェクイン数  
      this.checkInCount = this.apiCheckInData.rockyCheckInCount
      //チェックイン中のユーザーList
      this.apiCheckInUserList = this.apiCheckInData.checkingInUserList
      //岩別のチェックイン数      
      this.checkInAggregateList = this.apiCheckInData.aggregateList
      
      if(this.apiCheckInUserList.length ==0){
        //チェックイン中のユーザーが存在しない場合
        return
      }
      
      //先頭3ユーザー分のみ画面に表示する
      for(let i=0;  i<3;  i++) {
        if(this.apiCheckInUserList[i] != undefined){
          this.checkInUserList.push(this.apiCheckInUserList[i])
        }
      }

      //表示件数
      if(this.apiCheckInUserList.length > 3){
        this.checkInOtherCount = this.apiCheckInUserList.length - 3
        this.checkinOtherUserMessage = '他'+this.checkInOtherCount+'人がチェックインしています。'
      }else{
        this.checkInOtherCount = 0
        this.checkinOtherUserMessage =  this.checkInCount+'人がチェックインしています。'
      }

      //チェックインユーザー欄を表示する
      this.isCheckinUserListShow = true

    },
    //-----------------------------------
    // 現在チェックイン中のユーザーを取得する
    //-----------------------------------
    async getCheckingInUserAndCount(rockyId){
      let jsonUrl = ''
      if(this.$user.isLogin){
        //ログイン時
        jsonUrl = process.env.VUE_APP_API_GATEWAY + '/api-checkin/checkin-count-and-userlist-logined'
      }else{
        //未ログイン時
        jsonUrl = process.env.VUE_APP_API_GATEWAY + '/api-checkin/checkin-count-and-userlist-not-logined'
      }

      await axios
        .get(jsonUrl,{
          params: {
            'rockyId': rockyId,
          },         
          headers: {
            'Authorization': this.$user.idToken
          }
        })
        .then(response => {
          this.apiCheckInData = response.data
        })
        .catch(err => {
          this.falseInfo = true
        })
    }, 
    //---------------
    // 経度緯度を分割
    //---------------
    getLatLng(latLng){
      return latLng.split(',');
    },
    //---------------
    // 画像パスを生成
    //---------------
    createImgPath(path){
      return this.getRockThumbPath(path,this.rockyId,'360')
    },
    //---------------------------------------
    // 岩画像選択時の処理(Mapコンポーネントから呼ばれる)
    //---------------------------------------
    async callRouteList(rockId,rockName){

      this.rockId = rockId
      //ルート一覧のデータ取得とセット
      this.getRouteDataList(rockId)

      //ルート画面を表示する
      this.$router.push({ 
        name: 'rockyInfo_:rockyId_:rockId', 
        params: { 
          rockyId: this.$route.params.rockyId, 
          rockId:rockId,
          rockName:rockName,
          rockyMasterData:this.rockyMasterData,
        }
      })
    },
    //---------------------
    // ルート情報の取得処理
    //---------------------
    async getRouteDataList(paramRockId){

      let rockId = null

      if(paramRockId == undefined || paramRockId ==null){
        if(this.$route.params.rockId != undefined){
          rockId = this.$route.params.rockId
        }else if(this.$route.params.rockDataSet.rockId != undefined){
          rockId = this.$route.params.rockDataSet.rockId
        }else if(window.location.hash == '#routeView'){
          //ルート画像画面からブラウザバックされた場合
          rockId = this.rockId
        }
      }else{
        rockId = paramRockId
      }

      //岩情報を保持していない場合は再度取得する
      if(this.rockyMasterData==null){

        let json = await this.getRockyMasterData(this.rockyId,this.isLogin)
        if (json) {
          if(json.data.length==0){
            //対象のデータが存在しない場合
            this.$router.push('/rockyInfo/' + this.rockyId);  
          }
          this.rockyMasterData = json.data[0]
          this.rockyName = this.rockyMasterData['rockyName']
        }
      }

      //岩Listから対象の岩の情報を抽出する
      let rockList = this.rockyMasterData.rockList
      let targetRockData = rockList.find(element => element.id == rockId);
      if(!targetRockData){
        this.$router.push('/rockyInfo/' + this.rockyId);
      }

      //岩名
      this.rockName = targetRockData.name
      //岩画像のパス
      this.rockyImgPath = this.getRockThumbPath(targetRockData.imgList[0].path,this.rockyId,'360')

    },
    async dispErrorDialog(){
      await this.asyncDialog('データが存在しません')
    },
    //-----------------------------------
    // チェックイン中ユーザー一覧画面に遷移
    //-----------------------------------    
    showRockyCheckinUserList(){
      this.$router.push({ name: 'rockyInfo_:rockyId_checkingin_user_list',
                          params: {
                            checkinUserList: this.apiCheckInUserList, 
                            rockyName: this.rockyName}})
    },
    //------------------------
    // ユーザー情報モーダルOPEN
    //------------------------    
    showUserPage(item){
      this.$router.push('/myPage/' + item.id +'/userInfoTop')
    },
    callRouterPushCheckin(){
      this.$router.push('/myPage/' + this.$user.userId +'/checkInHistoryList')
    },
    callRouterPushRecord(){
      this.$router.push('/myPage/' + this.$user.userId +'/rockList?rockyId=' + this.rockyId)
    },
    getLink(target){
      let path = process.env.VUE_APP_URL + this.$route.path

      if(target=='facebook'){
        return "//www.facebook.com/sharer.php?src=bm&u=" + path + "&t=" + this.rockyName
      }else if(target=='twitter'){
        return "http://twitter.com/share?text=" + this.rockyName + "&url=" + path + "&via=&hashtags=ヤマラボ&related=yamalab"
      }else if(target=='line'){
        return "https://social-plugins.line.me/lineit/share?url=" + path
      }
    },
    //-------------
    // タブ切り替え
    //-------------
    changeTabAndRouterPush(target){
      this.changeTab(target)
      this.doRouterPush(target)
    },
    changeTab(target){
      //一旦全タブをfalseにする
      this.isTopTab = false
      this.isRockListTab = false
      this.isRouteListTab = false
      this.isMovieTab = false
      //初期化
      this.$refs.map.mapMessage = ''
      //タブの切り替えとURL(クエリストリング)の上書き
      switch (target){
        case 'rockyDetail':
          this.isTopTab = false
          this.rockyTopImgHeight = this.ROCKY_TOP_IMG_HEIGHT_LOW
          this.$refs.map.makeCsSpaControl()
          break
        case 'rockList':
          this.isRockListTab = true
          this.rockyTopImgHeight = this.ROCKY_TOP_IMG_HEIGHT_LOW
          break
        case 'routeList':
          this.isRouteListTab = true
          this.rockyTopImgHeight = this.ROCKY_TOP_IMG_HEIGHT_LOW
          break
        case 'movieList':
          this.isMovieTab = true
          this.rockyTopImgHeight = this.ROCKY_TOP_IMG_HEIGHT_LOW
          break
        default:
          //タブの指定がない場合ここに到達するので、TOPページに遷移する
          this.isTopTab = true
          this.$router.push('/rockyInfo/' + this.$route.params.rockyId, () => {}, () => {})
          break
      }
    },
    doRouterPush(target){
      if(target == 'rockyDetail'){
        this.$router.push('/rockyInfo/' + this.$route.params.rockyId, () => {}, () => {})
        return
      }
      if(target == 'feedBack'){
        this.$router.push('/feed_back/input', () => {}, () => {})
        return
      }
      //TODO:ブログ画面の場合の制御を追加する
      this.$router.push({ name: 'rockyInfo_:rockyId_'+ target}, () => {}, () => {})
    },
  },
}
</script>

<style lang="stylus" scoped>
#app .wrapper
  padding-top 0px

#breadcrumb
  .breadcrumb-item
    cursor pointer
  .active
    pointer-events none

//岩場TOP画像
#rocky-top-img
  width 100% //heightはtemplate側で設定している
  background-repeat no-repeat
  background-size cover
  background-position center
  position relative
  z-index 0
  color #fff
  &::before
    content ''
    position absolute
    width 100%
    height 100%
    background inherit
    filter brightness(80%)
    /* 最背面へ */
    z-index -1

  #rocky-info
    position absolute
    bottom 0
    left 0
    padding 1rem
    #checkin-info
      display inline
      padding 0 5px
      font-size 0.8rem
      text-decoration underline
      cursor pointer
      background rgba(120,103,19,0.8)
    #name
      font-size 1.5rem  
    #rockyNameKana
      font-size 0.9rem
    span
      font-size 0.8rem
      color rgba(0,0,0,0.9)
      background rgba(255,255,255,0.6)
      padding 0 3px


// SNS
#share
  margin 1rem -10px 0 -10px
  height 35px
  position relative
  img
    margin-left 1rem
    width 30px
    height 30px

// タブ
#tab-box
  height 55px
  margin 10px -15px 10px -15px
  text-align center
  .tab
    width 50%
    font-weight 600
    display flex
    justify-content center
    align-items center
    background rgba(236, 238, 239,0.5)
    cursor pointer
  .active
    background  #004170
    color #fff

// 子コンポーネント
#child-area
  background #fff

// 岩場特記事項
#rocky-remarks
  margin 0 -10px
  #rocky-remarks-inner
    background #eceeef
    color #df5f6a
    margin 1rem 0
    padding 5px
    border-radius 3px

// MAP
#map-container
  #rocky-map-inner
    //heightはhtml側で指定している
    margin-right -15px
    margin-left -15px
  .text-right
    font-size 0.5rem


// 記録作成  TODO:不要な場合消す
.create-record-row
  margin-bottom 1rem
  text-align right
  .linkExist
    text-decoration underline
    cursor pointer

// レベルグラフ
#chart-container
  margin 0 -15px
  #chart-container-innner
    width 100%
    height 210px
    background-color #171d32
    padding-top 5px
    #guide
      width 55px
      background #006FBE
      margin-left 5px
      p
        text-align center
        color white
        font-size 0.7rem

    #bar-chart
      padding-top 10px
      #bar-box-innner
        display flex
        margin 0 15px
        justify-content space-between
        .box
          width: 100%
          .bar
            position relative
            width 70%
            height 80px
            margin 0 auto 5px auto
            .bar-line
              width 100%
              background #006FBE
              position absolute
              bottom 0
            a
              position absolute
              left 50%
              transform translateX(-50%)
              -webkit-transform translateX(-50%)
              -ms-transform translateX(-50%)
              font-size 0.7rem
              color #adb4b9
          .index
            text-align center
            backgroud green
            font-size 10px
            color #86898d 
            .bolder
              a
                transform scale(0.3)
            .rope
              a
                transform scale(0.8)
                white-space pre-wrap // 改行コードを有効にする

// 岩場データ、チェックイングラフ
.full-width-wrapper
  margin 0 -15px
  .headline
    width 100%
    //font-weight 500
    padding 5px 0 5px 10px
    font-weight 600
    color #ffffff
    background #004170

  .rockydata
    background #eceeef

  // グラフ
  .chart,.chart-data-not-exist
    width 100%
    // グラフの背景色
    background #eceeef
  .chart-data-not-exist
    padding 1rem

.spinner
  text-align center

button
  background #0087D0
  border-color #0087D0
  &:active
    background #0664a9
    border-color #0664a9
  &:hover
    background #0664a9
    border-color #0664a9
  &:focus
    background #0087D0
    border-color #0087D0   

#topo_button_danger
  background #dc3545
  border-color #dc3545


// 大デバイス（デスクトップ, 992px 以上）
@media (min-width 992px)
  #rocky-top-img
    #rocky-info
      padding-left 10vw
      #checkin-info
        font-size 1.1rem
      #rockyNameKana
        font-size 1rem
      #name
        font-size 1.8rem
      #level
        font-size 0.8rem

  // レベルグラフ
  #chart-container
    #chart-container-innner
      #bar-chart
        #bar-box-innner
          margin 0 30px

          
</style>